//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "VillageSetQuery",
};
